// extracted by mini-css-extract-plugin
module.exports = {"accordionsDiv":"Accordions_accordionsDiv__7SeA5"};